import { jsx as _jsx } from "react/jsx-runtime";
import { useBrandConfiguration } from '@search/core/brands/context';
import { MapListButton as CoreMapListButton } from '@search/core/components/MapListButton';
import { useAppContext } from '../../contexts/AppContext';
import { useLoaded } from '../../hooks/useLoaded';
import { useMapListButton } from '../../hooks/useMapListButton';
export const MapListButton = () => {
    const [searchModel, order, page] = useAppContext((store) => [store.searchModel, store.order, store.page]);
    const { defaultOrder } = useBrandConfiguration();
    const shouldDisplay = useMapListButton();
    const isLoaded = useLoaded();
    const isDisplayed = isLoaded && searchModel && shouldDisplay;
    return (isDisplayed && (_jsx(CoreMapListButton, { view: "list", searchModel: searchModel, order: order, page: page, defaultOrder: defaultOrder })));
};
